import { toast } from 'react-toastify';
import { generateUuid } from '../../../utils/randomString';
import { blogEditFun, blogUploadFun } from '../../../api/addDataAPI';
import fileUpload from '../../../utils/fileUpload';
import deleteFile from '../../../utils/deleteFile';

export default async function blogSubmit(blog, userId, setLoading) {
    if (blog.name.length < 10) {
        toast.error('Name should be minimum 10 characters');
        return;
    }
    if (blog.name.length > 60) {
        toast.error('Name should be not more than 60 characters');
        return;
    }
    if (blog.shortDescription.length < 50) {
        toast.error('Short descritption should be minimum 50 characters');
        return;
    }
    if (blog.shortDescription.length > 5000) {
        toast.error('Short descritption should be not more than 5000 characters');
        return;
    }

    const uuid = generateUuid();

    try {
        setLoading(true);
        const description = await Promise.all(
            blog.description.map(async (section) => {
                const totalDescriptionLength = section.description.reduce(
                    (acc, paragraph) => acc + paragraph.length,
                    0
                );
                if (section.title.length < 10) {
                    setLoading(false);
                    toast.error('Short description should be minimum 50 characters');
                    return null;
                }
                if (section.title.length > 50) {
                    setLoading(false);
                    toast.error('Short description should be not more than 150 characters');
                    return null;
                }
                if (totalDescriptionLength < 50) {
                    setLoading(false);
                    toast.error('Description should not be less than 250 characters');
                    return null;
                }
                if (totalDescriptionLength > 5000) {
                    setLoading(false);
                    toast.error('Description should be less than 5000 characters');
                    return null;
                }
                if (section.newImage && section.oldImage) {
                    deleteFile(section.oldImage);
                }

                const sectionImageUrl = section.newImage
                    ? await fileUpload(section.newImage, '', 'blog', 'section-image')
                    : '';

                return {
                    title: section.title,
                    description: section.description,
                    image: sectionImageUrl ? sectionImageUrl : section.oldImage
                };
            })
        );

        if (blog.newImage && blog.oldImage) {
            deleteFile(blog.oldImage);
        }
        const mainImageUrl = blog.newImage ? await fileUpload(blog.newImage, '', 'blog', 'blog-image') : '';

        const blogData = {
            name: blog.name,
            shortDescription: blog.shortDescription,
            description: description,
            image: mainImageUrl ? mainImageUrl : blog.oldImage,
            author: userId,
            tags: blog.tags,
            imageRefId: uuid
        };
        let response;

        if (blog?._id) {
            response = await blogEditFun(blog._id, blogData);
        } else {
            response = await blogUploadFun(blogData);
        }
        if (response.status === 200) {
            toast.success('Blog uploaded successfully!');
            return response.status;
        }
        setLoading(false);
    } catch (error) {
        console.log(error);
        setLoading(false);
        toast.error('An error occurred while submitting the blog');
    }
}
